<script>


import moment from "moment";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  components: {

  },
  props: {
    pedidoList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    updating: {
      type: Boolean,
    },
  },

  data() {
    return {
      loadingPedidoDetail: false,
      valorTotalItens: 0,
      titleModalItensPed: 'Resumo de Pedido',
      showModalItensPed: false,
      clienteData: {},
      pedidoData: {},
      pedidoItensData: {},
    };
  },

  mounted() {
    console.log('mounted pedidos-table')
    console.log(this.updating)
  },
  methods: {

    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'FA':
          result = 'Faturado'
          break
        case 'EL':
          result = 'Elaboração'
          break
        case 'CA':
          result = 'Cancelado'
          break
        case 'CO':
          result = 'Confirmado'
          break
        default:
          result = 'Não Definido'
          break
      }
      return result
    },

    nomeStatusSefaz(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'XM':
          result = 'XML Disponível'
          break
        case 'AT':
          result = 'NFe Autorizada'
          break
        case 'CA':
          result = 'NFe Cancelada'
          break
        case 'EV':
          result = 'Envio para Sefaz pendente'
          break
        case 'NG':
          result = 'Negado pelo Sefaz'
          break
        default:
          result = 'Não Definido'
          break
      }
      return result
    },

    editar(idData){
      console.log('editar: ' + idData)
      this.$router.push(`/pedido/detalhe/${idData}`)
    },

    detalhes(idData){
      console.log('detalhes_0: ' + idData)
      this.loadingPedidoDetail = true
      this.showModalItensPed = true
      this.valorTotalItens = 0

      api.get(`${getBaseUrl()}api/pedido`, {
        params: { iddata: idData }
      }).then((res) => {
        console.log('then axios_detalhe')
        this.pedidoData = res.data[0]
        this.clienteData = res.data[1]
        this.pedidoItensData = res.data[2]

        console.log(res.data)

        if (this.pedidoItensData.length > 0){
          this.pedidoItensData.forEach((value) => {

            console.log('value.imgs')
            console.log(value.imgs)

            let imgTrat = value.imgs.split(',')
            // if (value.imgs.includes(',')){
            //   imgTrat = value.imgs.split(',')[0]
            // }else{
            //   imgTrat = value.imgs
            // }

            value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
            // console.log(value.vlrtotalliq);
            let valorliq = parseFloat(value.valorliq)
            this.valorTotalItens += valorliq
          });
        }


        this.titleModalItensPed = `Resumo de Pedido (${ this.pedidoData.id })`
        this.loadingPedidoDetail = false
      })
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },
  }
};
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table align-middle table-nowrap">
      <thead class="table-light">
      <tr>

        <th class="align-middle">ID</th>
        <!-- <th class="align-middle">Código</th> -->
        <th class="text-center">CNPJ Emissor</th>
        <th class="text-center">Cliente</th>
        <th class="align-middle">CNPJ destino</th>
        <th class="align-middle">Cidade</th>
        <th class="align-middle">Estado</th>
        <th class="align-middle">Data</th>
        <th class="align-middle">Status</th>
        <th class="align-middle">Condição</th>
        <th class="align-middle">Forma</th>
        <th class="align-middle text-end">Peso</th>
        <th class="align-middle text-end">Valor</th>
        <th class="text-end">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="data in pedidoList" :key="data.id">


        <td>
          <a href="javascript: void(0);" @click="editar(data.id)" class="text-body fw-bold">{{
              data.id
            }}</a>
        </td>

        <td class="text-center">
          {{ data.empresa_cnpj }}
        </td>

        <!-- <td>
          <a href="javascript: void(0);" @click="editar(data.id)" class="text-body fw-bold">{{
              data.codigo
            }}</a>
        </td> -->

        <td class="text-center">{{ data.nomecli }}</td>
        <td>{{ data.cnpj }}</td>
        <td>{{ data.cidade }}</td>
        <td>{{ data.estado }}</td>
        <td>{{ formatDateTime(data.created_at) }}</td>


        <td>
              <span
                  class="badge badge-pill badge-soft-success font-size-11"
                  :class="{
                  'badge-soft-info': `${data.status}` === 'CO',
                  'badge-soft-danger': `${data.status}` === 'CA',
                  'badge-soft-success': `${data.status}` === 'FA',
                }">{{ nomeStatus(data.status) }} </span>
          <p></p>


          <span
              class="badge badge-pill badge-soft-success font-size-11"
              :class="data.stsefaz === 'AT' ? 'badge-soft-success'
                  :data.stsefaz === 'XM' ? 'badge-soft-warning'
                  :data.stsefaz === 'EV' ? 'badge-soft-warning' : 'badge-soft-danger'">
                {{ nomeStatusSefaz(data.stsefaz)  }}
              </span>


        </td>

        <td>
          {{ data.desccond }}
        </td>

        <td>
          {{ data.formapgtodesc }}
        </td>
        <td class="text-end">{{ formatDecimal(data.peso) }}</td>
        <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
        <td>

          <div class="button-items text-end">

            <b-button variant="outline-success" @click="detalhes(data.id)">
              <i class="mdi mdi-eye d-block font-size-16"></i>
            </b-button>

            <b-button variant="outline-warning" @click="editar(data.id)" :disabled="data.email === 'admin@admin.com.br'">
              <i class="mdi mdi-pencil d-block font-size-16"></i>
            </b-button>

          </div>

        </td>

      </tr>
      </tbody>
    </table>




    <b-modal :title="titleModalItensPed" v-model="showModalItensPed" centered hide-footer >

      <div class="row" v-if="loadingPedidoDetail">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingPedidoDetail && pedidoData && clienteData">


        <p class="mb-2">
          Código:
          <span class="text-primary">{{ pedidoData.id }}</span>
        </p>
        <p class="mb-4">
          <router-link :to="`/cliente/detalhe/${clienteData.id}`" target="_blank">
            Cliente:
            <span class="text-primary">{{ pedidoData.cliente }} - {{ clienteData.nome }}</span>
          </router-link>
        </p>
        <div class="table-responsive">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Produto</th>
              <th scope="col">Descrição</th>
              <th scope="col">Valor</th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="data in pedidoItensData" :key="data.id">
              <th scope="row">
                <div>
                  <img :src="data.img1"
                       alt
                       class="avatar-sm"/>
                </div>
              </th>
              <td>
                <div>
                  <h5 class="text-truncate font-size-14">
                    {{ data.descprod.substring(0, 32) }}
                  </h5>
                  <p class="text-muted mb-0">R$ {{ formatDecimal(data.vlrunitliq) }} x {{ formatInteger(data.qtd) }}</p>
                </div>
              </td>
              <td class="text-end">{{ formatDecimal(data.vlrtotalliq) }}</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Sub Total:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(valorTotalItens) }}</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Frete:</h6>
              </td>
              <td class="text-end">Grátis</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Total:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(valorTotalItens) }}</td>
            </tr>

            </tbody>
          </table>
        </div>
      </div>
    </b-modal>

  </div>
  <!-- end table -->
</template>